import { createReducer } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

import {
  bookStudentClassBanner,
  changeBookingStatus,
  resetClassBannerBookingError,
  resetChangeBookingStatusError,
  submitClassReview,
} from './classBannerBooking.actions'

const initialState = {
  loading: {
    bookStudentClassBanner: false,
    changeBookingStatus: false,
    submitClassReview: false,
  },
  error: {
    bookStudentClassBanner: null,
    changeBookingStatus: null,
    submitClassReview: null,
  },
}

const classBannerBookingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(bookStudentClassBanner.fulfilled, (state) => {
      state.loading.bookStudentClassBanner = false
      state.error.bookStudentClassBanner = null
    })
    .addCase(bookStudentClassBanner.pending, (state) => {
      state.loading.bookStudentClassBanner = true
      state.error.bookStudentClassBanner = null
    })
    .addCase(bookStudentClassBanner.rejected, (state, action) => {
      state.loading.bookStudentClassBanner = false
      state.error.bookStudentClassBanner = action.error?.message || null
    })

    .addCase(submitClassReview.fulfilled, (state) => {
      state.loading.submitClassReview = false
      state.error.submitClassReview = null
    })
    .addCase(submitClassReview.pending, (state) => {
      state.loading.submitClassReview = true
      state.error.submitClassReview = null
    })
    .addCase(submitClassReview.rejected, (state, action) => {
      state.loading.submitClassReview = false
      state.error.submitClassReview = action.error?.message || null
    })

    .addCase(changeBookingStatus.fulfilled, (state) => {
      state.loading.changeBookingStatus = false
      state.error.changeBookingStatus = null
    })
    .addCase(changeBookingStatus.pending, (state) => {
      state.loading.changeBookingStatus = true
      state.error.changeBookingStatus = null
    })
    .addCase(changeBookingStatus.rejected, (state, action) => {
      state.loading.changeBookingStatus = false
      state.error.changeBookingStatus = action.error?.message || null
    })

    .addCase(resetClassBannerBookingError, (state) => {
      state.error.bookStudentClassBanner = null
    })

    .addCase(resetChangeBookingStatusError, (state) => {
      state.error.changeBookingStatus = null
    })

    .addDefaultCase((state) => state)
})

export const classBannerBookingState = (state) => state.classBannerBooking

export const selectLoadingBookStudentClassBanner = createSelector(
  classBannerBookingState,
  ({ loading: { bookStudentClassBanner } }) => bookStudentClassBanner
)

export const selectErrorBookStudentClassBanner = createSelector(
  classBannerBookingState,
  ({ error: { bookStudentClassBanner } }) => bookStudentClassBanner
)

export const selectLoadingChangeBookingStatus = createSelector(
  classBannerBookingState,
  ({ loading: { changeBookingStatus } }) => changeBookingStatus
)

export const selectErrorChangeBookingStatus = createSelector(
  classBannerBookingState,
  ({ error: { changeBookingStatus } }) => changeBookingStatus
)
export const selectErrorsubmitClassReview = createSelector(
  classBannerBookingState,
  ({ error: { submitClassReview } }) => submitClassReview
)

export default classBannerBookingReducer
